export default __webpack_public_path__ + "static/media/DBlogo.0b57423e.svg";